import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  tooltip: {
    fontSize: theme.typography.h4.fontSize,
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(2, 2),
  },
});

export const ParagraphTooltip = withStyles(styles)(Tooltip);
